import config from '@/lib/config';
import { PLATFORM_FEATURES_ENUM } from '@/lib/constants';
import { useAuth } from '@/state/auth';

const useFeature = () => {
  const isFeatureEnabled = useAuth(state => state.isFeatureEnabled);

  // CAPA RELATED FEATURES
  const isCapaFeatureEnabled = () => {
    return isFeatureEnabled(PLATFORM_FEATURES_ENUM.CAPA);
  };

  const isCapaBasicFeatureEnabled = () => {
    return isFeatureEnabled(PLATFORM_FEATURES_ENUM.CAPA_BASIC);
  };

  const isCapaAdvancedFeatureEnabled = () => {
    return isFeatureEnabled(PLATFORM_FEATURES_ENUM.CAPA_ADVANCED);
  };

  const isCapaBasicOrAdvancedFeatureEnabled = () => {
    return isCapaBasicFeatureEnabled() || isCapaAdvancedFeatureEnabled();
  };

  const isAnyCapaFeatureEnabled = () => {
    return (
      isCapaFeatureEnabled() ||
      isCapaBasicFeatureEnabled() ||
      isCapaAdvancedFeatureEnabled()
    );
  };

  const isViewNetworkUsersInfoEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.VIEW_NETWORK_USERS_INFO,
  );
  const isAuditAIEnabled = isFeatureEnabled(PLATFORM_FEATURES_ENUM.AUDIT_AI);
  const isCompanyServiceEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.COMPANY_PROFILES,
  );
  const isItcIntegrationFeatureEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.ITC_INTEGRATION,
  );
  const isSlcpAssessmentFeatureEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.SLCP_ASSESSMENT,
  );
  const isKharonEntityListFeatureEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.KHARON_ENTITY_LIST,
  );
  const isCapaV2Enabled = isFeatureEnabled(PLATFORM_FEATURES_ENUM.CAPA_V2);
  const isTracingAiEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.TRACING_AI,
  );
  const isCertifiedMaterialsManagementEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.CERTIFIED_MATERIALS_MANAGEMENT,
  );
  const isProductMappingFeatureEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.PRODUCT_MAPPING,
  );
  const isEntityScreeningV2Enabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.ENTITY_SCREENING_V2,
  );
  const isKharonV2Enabled = isFeatureEnabled(PLATFORM_FEATURES_ENUM.KHARON_V2);
  const isDigitizedAuditsEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.DIGITIZED_AUDITS,
  );
  const isDropBoxEnabled = isFeatureEnabled(PLATFORM_FEATURES_ENUM.DROP_BOX);
  const isSupplyChainMappingProductStoryFeatureEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.SUPPLY_CHAIN_MAPPING_PRODUCT_STORY,
  );
  const isCascadeTracingFeatureEnabled = isFeatureEnabled(
    PLATFORM_FEATURES_ENUM.CASCADE_TRACING,
  );
  //set true in config for release to all else use feature
  const isNewStyleStructureEnabled =
    config.isStyleStructureEnabled ||
    isFeatureEnabled(PLATFORM_FEATURES_ENUM.NEW_STYLE_STRUCTURE);

  // You can add your platform feature here as well if you want
  // so we all can benefit from this hook.

  return {
    isFeatureEnabled,
    isCapaFeatureEnabled,
    isCapaBasicFeatureEnabled,
    isCapaAdvancedFeatureEnabled,
    isCapaBasicOrAdvancedFeatureEnabled,
    isAnyCapaFeatureEnabled,
    isProductMappingFeatureEnabled,
    isSupplyChainMappingProductStoryFeatureEnabled,
    isCascadeTracingFeatureEnabled,
    isViewNetworkUsersInfoEnabled,
    isAuditAIEnabled,
    isCompanyServiceEnabled,
    isItcIntegrationFeatureEnabled,
    isSlcpAssessmentFeatureEnabled,
    isKharonEntityListFeatureEnabled,
    isCapaV2Enabled,
    isTracingAiEnabled,
    isCertifiedMaterialsManagementEnabled,
    isNewStyleStructureEnabled,
    isEntityScreeningV2Enabled,
    isKharonV2Enabled,
    isDigitizedAuditsEnabled,
    isDropBoxEnabled,
  };
};

export default useFeature;
